<template>
  <div
    class="offcanvas offcanvas-fullscreen-sm-down offcanvas-end"
    tabindex="-1"
    id="offcanvaInfo"
    ref="offcanvaInfo"
    data-bs-backdrop="static"
  >
    <!-- data-bs-backdrop="static" -->
    <div class="bg-top-nav border offcanvas-header py-2">
      {{ $t('Shift Detail')  }}
      <button
        type="button"
        style="font-size: small;"
        class="btn-close shadow-none text-reset"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      />
    </div>
    <div
      class="offcanvas-body"
      v-if="loading"
    >
      <placeholder-content :is-load="true" />
    </div>
    <div
      class="offcanvas-body"
      v-else-if="!hasPermission"
    >
      <access-denied/>
    </div>
    <div
      class="offcanvas-body p-0"
      v-else
    >
      <div class="border-bottom py-2 px-3">
        <div class="d-flex justify-content-between">
          <div>
            <b style="font-size: 18px;" class="mt-2 me-1">
              {{ data.branch }}
            </b>
            <div
              class="d-flex mt-0 "
              style="font-size: 13px;"
            >
              {{ $t('Last Update') + ': ' + formatDateTime(data.updated_at) }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="card m-3"
      >
        <div class="card-header">
          {{ $t('Shift Information') }}
        </div>
        <div class="card-body pb-0">
          <div class="row" style="font-size: 13px;">
            <div class="col-md-2 mb-3">
              <b>
                {{ $t('Opened By') }}
              </b><br>
              {{ data.opened_by }}
            </div>
            <div class="col-md-2 mb-3">
              <b>
                {{ $t('Opening Time') }}
              </b><br>
              {{ dateDistance(data.started_at) }}
            </div>
            <div class="col-md-2 mb-3">
              <b>
                {{ $t('Starting Cash') }}
              </b><br>
              {{ $storeIndex.formatThaiCurrency(data.starting_cash) }}
            </div>
            <div class="col-md-2 mb-3">
              <b>
                {{ $t('Total Pay In') }}
              </b><br>
              {{ $storeIndex.formatThaiCurrency(data.total_pay_in) }}
            </div>
            <div class="col-md-2 mb-3">
              <b>
                {{ $t('Total Pay Out') }}
              </b><br>
              <span class="text-danger">
                {{ $storeIndex.formatThaiCurrency(data.total_pay_out * -1) }}
              </span>
            </div>
            <!-- <div class="col-md-3 mb-3">
              <b>
                {{ $t('Create By') + ': ' }}
              </b>
              {{ data.created_by }}<br>
              <b>
                {{ $t('Created At') + ': ' }}
              </b>
              {{ formatDateTime(data.created_at) }}
            </div> -->
          </div>
        </div>
      </div>
      <div
        class="card m-3"
      >
        <div class="card-body">
          <h5>
            <b>
              {{ $t('Current Sales Summary') }}
            </b>
          </h5>
          <div class="gx-2 row">
            <div class="col-md-3 mb-3">
              <div class="bg-success card text-white">
                <div class="card-body">
                  <p class="card-text">
                    {{ $t('Gross Sales') }}
                  </p>
                  <h3 class="card-title text-end">
                    {{ $storeIndex.formatThaiCurrency(data.gross_sales) }}
                  </h3>
                </div>
              </div>
            </div>
            <div class="col-md-3 mb-3">
              <div class="bg-danger card text-white">
                <div class="card-body">
                  <p class="card-text">
                    {{ $t('Refunds/Voids') }}
                  </p>
                  <h3 class="card-title text-end">
                    {{ $storeIndex.formatThaiCurrency(data.total_refund) }}
                  </h3>
                </div>
              </div>
            </div>
            <div class="col-md-3 mb-3">
              <div class="bg-primary card text-white">
                <div class="card-body">
                  <p class="card-text">
                    {{ $t('Net Sales') }}
                  </p>
                  <h3 class="card-title text-end">
                    {{ $storeIndex.formatThaiCurrency(data.net_sales) }}
                  </h3>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="bg-secondary card text-white">
                <div class="card-body">
                  <p class="card-text">
                    {{ $t('Total Transactions') }}
                  </p>
                  <h3 class="card-title">
                    {{ data.transaction_count + ' ' + $t('Bills') }}
                  </h3>
                </div>
              </div>
            </div>
          </div>
          <h5>
            <b>
              {{ $t('Payment Breakdown') }}
            </b>
          </h5>
          <!-- เฉพาะช่องทางที่สาขานี้เปิดใช้จริง — สาขาที่รับแต่เงินสดจะเห็นการ์ดเดียว -->
          <div class="gx-2 row">
            <div
              class="col-md-4 mb-3"
              v-for="payment in (data.payment_breakdown ?? [])"
              :key="payment.branch_payment_method_id || ('method-' + payment.payment_method_id)"
            >
              <div class="bg-secondary-subtle card px-2">
                <div class="card-body d-flex justify-content-between p-1">
                  <span class="card-text">
                    {{ $t(payment.label) }}
                  </span>
                  <span class="card-text">
                    {{ $storeIndex.formatThaiCurrency(payment.sales_amount) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="m-3">
        <div class="row g-3">
          <div class="col-md-6">
            <div
              class="card"
            >
              <div class="card-header">
                {{ $t('Cash Drawer Actions') }}
              </div>
              <div class="card-body">
                <div class="row g-2" style="font-size: 13px;">
                  <div class="col-md-6 d-grid">
                    <button
                      type="button"
                      class="btn btn-outline-primary btn-sm"
                      @click="() => {
                        modalPayInPayOut.open = true;
                        modalPayInPayOut.type = 'IN'
                      }"
                    >
                      <i class="fa-solid fa-plus me-1" />
                      {{ $t('Pay In') }}
                    </button>
                  </div>
                  <div class="col-md-6 d-grid">
                    <button
                      type="button"
                      class="btn btn-outline-primary btn-sm"
                      @click="() => {
                        modalPayInPayOut.open = true;
                        modalPayInPayOut.type = 'OUT'
                      }"
                    >
                      <i class="fa-solid fa-minus me-1" />
                      {{ $t('Pay Out') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div
              class="card"
            >
              <div class="card-header">
                {{ $t('Shift Control') }}
              </div>
              <div class="card-body">
                <div class="row g-2" style="font-size: 13px;">
                  <!-- <div class="col-md-6 d-grid">
                    <button type="button" class="btn btn-secondary btn-sm">
                      <i class="fa-solid fa-print me-1" />
                      {{ $t('Print Summary') }}
                    </button>
                  </div> -->
                  <div class="col-md-6 d-grid">
                    <button
                      type="button"
                      class="btn btn-danger btn-sm"
                      data-bs-dismiss="offcanvas"
                      aria-label="Close"
                      @click="() => {
                        $emit('open-finalize-close-shift');
                      }"
                    >
                      {{ $t('Close Shift') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <modal-pay-in-pay-out
    v-if="modalPayInPayOut.open"
    :type="modalPayInPayOut.type"
    @close="() => {
      modalPayInPayOut.open = false;
    }"
  />
</template>

<script lang="js">
import { useVuelidate } from '@vuelidate/core';
import { POSRegisters } from '@/services/endpoint/pos.service';
import PlaceholderContent from '@/plugins/PlaceholderContent.vue';
import AccessDenied from "@/plugins/AccessDenied.vue";
import Ladda from '@/plugins/Ladda.vue';
import moment from "moment";
import numeral from 'numeral';
import { distance } from '@/store/date-fns';
import validation from "./assets/template/validation";
import ModalPayInPayOut from './ModalPayInPayOut.vue';
import { useScrollRestore } from '@/composables/useScrollRestore';

export default {
  setup: () => ({ v$: useVuelidate() }),
  validations() {
    return validation(this.data)
  },
  props: {
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      hasPermission: false,
      isHovered: false,
      loadingCard: true,
      loading: true,
      data: {},
      canSubmit: true,
      modalPayInPayOut: {
        open: false,
        type: 'IN'
      }
    }
  },
  components: {
    PlaceholderContent,
    AccessDenied,
    Ladda,
    ModalPayInPayOut
  },
  methods: {
    formatNumber(value) {
      return numeral(value).format("0,0");
    },
    formatDigit(value) {
      if ((value < 0.01) && value != 0) {
        return numeral(value).format("0,0.0000");
      }
      return numeral(value).format("0,0.00");
    },
    formatNumberDigit(value) {
      return numeral(value).format("0,0.0000");
    },
    formatNumberTwoDigit(value) {
      return numeral(value).format("0,0.00");
    },
    async getInfoData() {
      await POSRegisters.shiftInfo(this.id).then(res => {
        this.data = res.data.data;
        this.hasPermission = true;
        this.loading = false;
      }).catch(err => {
        this.hasPermission = false;
        this.loading = false;
			  throw err;
      });
    },
    formatDate(value) {
      return moment(value).format('DD/MM/YYYY');
    },
    formatDateTime(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss');
    },
    dateDistance(value) {
      return distance(value);
    }
  },
  async mounted() {
    $(this.$refs.offcanvaInfo).offcanvas('show');

    $(this.$refs.offcanvaInfo).on('shown.bs.offcanvas',async () => {
      try {
        this.loading = true;
        await this.getInfoData();
      } catch (err) {
      }
    });

    $(this.$refs.offcanvaInfo).on('hidden.bs.offcanvas', () => {
      this.$emit('close');
    });

    useScrollRestore(() => this.$refs.offcanvaInfo?.querySelector('.offcanvas-body'));
  },
  computed: {
  },
  watch: {
  }
}
</script>
